module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/fin/openingbalances/openingbalances-show/openingbalances-show.component.scss
// module id = ./src/app/views/fin/openingbalances/openingbalances-show/openingbalances-show.component.scss
// module chunks = main